import type React from 'react';
import { ProductExportView } from './ProductExportView';
import { useProductExport, type ProductExportProps } from './useProductExport';

/** Runs the export section's hook and hands its state to the View. */
export const ProductExportContent: React.FC<ProductExportProps> = ({
    scope,
}) => {
    const state = useProductExport(scope);
    return <ProductExportView {...state} />;
};
